(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score-parts/event-row-header.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-score-parts/event-row-header.js');
"use strict";


const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const getAriaLabel = (eventItem, eventIndex, isMobile) => {
  const {
    awayTeamShort,
    awayTeamLong,
    homeTeamShort,
    homeTeamLong
  } = eventItem;
  return "Match ".concat(eventIndex + 1, ", ").concat(isMobile ? "".concat(homeTeamShort, " mot ").concat(awayTeamShort) : "".concat(homeTeamLong, " mot ").concat(awayTeamLong), ".");
};
const EventRowHeader = _ref => {
  let {
    eventIndex,
    eventItem,
    branding
  } = _ref;
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const {
    captionShort,
    captionLong
  } = eventItem;
  return React.createElement("p", {
    "aria-label": getAriaLabel(eventItem, eventIndex, isMobile),
    className: "u-flex u-flex-align-items-center u-flex-justify-content-center margin-bottom-0 coupon-score-event-header coupon-score-event-header-".concat(branding),
    "data-testid": "event-".concat(eventIndex, "-description")
  }, "".concat(isMobile ? captionShort : captionLong));
};
setGlobal('svs.components.sport.quickplayModal.coupons.CouponScoreParts.EventRowHeader', EventRowHeader);

 })(window);